import './App.scss';
import { AppRoute } from './app/AppRoute';
import { Config } from './features/config/Config';
import { AuthProvider } from './features/auth/AuthProvider';
import { TopBar } from './features/top-bar/TopBar';

function App() {
  return (
    <div className="App">
      <Config>
        <AuthProvider>
          <TopBar />
          <AppRoute />
        </AuthProvider>
      </Config>
    </div>
  );
}

export default App;
